import { useState, useEffect } from "react";
import { postSynthesisURL } from "../../utils/ConstantsURL";

const useEditSynthesis = (token, note, onSaveSuccess, onClose) => {
  const [title, setTitle] = useState("");
  const [synthesis, setSynthesis] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    if (note) {
      setTitle(note.titulo || "");
      setSynthesis(note.sintesis || "");
      setError(null);
      setSaveSuccess(false);
    }
  }, [note]);

  const handleSynthesisChange = (e) => {
    setSynthesis(e.target.value);
  };

  const handleSubmit = async () => {
    if (!synthesis.trim() || !note) return;

    const noteId = note.cvcapsula;

    if (!noteId) {
      setError("ID de nota no encontrado");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(postSynthesisURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          synthesis: synthesis.trim(),
          note_id: noteId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al actualizar la síntesis");
      }

      setSaveSuccess(true);
      onSaveSuccess();

      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (err) {
      setError(err.message || "Error al guardar los cambios");
      console.error("Error al actualizar la síntesis:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return {
    title,
    synthesis,
    loading,
    error,
    saveSuccess,
    setSaveSuccess,
    handleSynthesisChange,
    handleSubmit,
    handleClose,
  };
};

export default useEditSynthesis;
